import QualAPI from 'utils/QualAPI';
import useUpdateCodeField from './useUpdateCodeField';
import { useOptimisticPromise } from 'hooks/optimistic/useOptimisticPromise';


/**
 * Hook for renaming a code with optimistic updates
 * @returns {Object} The mutation object with mutate function and state
 */
export function useRenameCode() {
  const { waitForPromise } = useOptimisticPromise();
  return useUpdateCodeField(
    async ({ codeId, name }) => {
      const resolvedCodeId = await waitForPromise(codeId);
      return QualAPI.renameCode(resolvedCodeId, name).then(response => response.data)
    },
    'Error renaming code'
  );
}
